import React from 'react';
import { Layout } from '../components/Layout';
import { useData } from '../contexts/DataContext';
import { useT } from '../lib/i18n';
import { Phone, Mail, MapPin, Trash2 } from 'lucide-react';
import { toast } from 'sonner';

export default function Clients() {
  const { clients, deleteClient } = useData();
  const { t } = useT();

  const onDelete = async (c) => {
    if (!window.confirm(`${t('common.delete')} ${c.name} ?`)) return;
    await deleteClient(c.id);
    toast.success('✓');
  };

  return (
    <Layout title={t('clients.title')}>
      <h1 className="font-heading text-4xl font-black tracking-tighter mb-6">{t('clients.title')}</h1>
      {clients.length === 0 ? (
        <div className="card p-8 text-center text-gray-500" data-testid="empty-clients">{t('clients.empty')}</div>
      ) : (
        <div className="space-y-3">
          {clients.map((c) => (
            <div key={c.id} className="card p-4" data-testid={`client-row-${c.id}`}>
              <div className="flex items-start justify-between gap-3 mb-2">
                <div className="font-bold text-lg">{c.name}</div>
                <button onClick={() => onDelete(c)} className="p-2 text-red-700 hover:bg-red-50 rounded-lg" data-testid={`client-delete-${c.id}`}>
                  <Trash2 size={16} />
                </button>
              </div>
              <div className="space-y-1 text-sm text-gray-600">
                {c.address && <div className="flex items-center gap-2"><MapPin size={13} /> {c.address}</div>}
                {c.phone && <div className="flex items-center gap-2"><Phone size={13} /> {c.phone}</div>}
                {c.email && <div className="flex items-center gap-2"><Mail size={13} /> {c.email}</div>}
              </div>
            </div>
          ))}
        </div>
      )}
    </Layout>
  );
}
